import React from "react";

const MEET_PAGE_PATH = "/bourbon-city-spectacular";

const MeetPageEmptyState = ({ days = 30, variant = "no-data" }) => {
  const isSetup = variant === "not-connected";

  return (
    <div className="owner-dashboard__meet-empty">
      <p className="owner-dashboard__meet-empty-eyebrow">Bourbon City Spectacular</p>
      <h3 className="owner-dashboard__meet-empty-title">
        {isSetup ? "Analytics not connected yet" : "No meet page data yet"}
      </h3>
      <p className="owner-dashboard__meet-empty-lead">
        {isSetup
          ? "Google Analytics needs to be connected before this tab can show how the meet page is performing."
          : `Nothing from the meet page has reached Google Analytics in the last ${days} days. That usually means no one has visited the page yet — not that tracking is broken.`}
      </p>

      {!isSetup && (
        <>
          <div className="owner-dashboard__meet-empty-card">
            <p className="owner-dashboard__meet-empty-card-title">Tracking is already live</p>
            <p className="owner-dashboard__meet-empty-card-text">
              Visits, register button clicks, section scroll depth, FAQ opens, venue
              directions, and more are being recorded automatically.
            </p>
          </div>

          <div className="owner-dashboard__meet-empty-card owner-dashboard__meet-empty-card--muted">
            <p className="owner-dashboard__meet-empty-card-title">When traffic picks up, you will see</p>
            <ul className="owner-dashboard__meet-empty-list">
              <li>Page visits and register click conversion</li>
              <li>Which register button people use (top, sticky bar, bottom)</li>
              <li>How far down the page families scroll</li>
              <li>FAQ questions they open and Bardstown tourism clicks</li>
            </ul>
          </div>

          <p className="owner-dashboard__meet-empty-foot">
            Share the meet page in email, social, or gym communications to start
            collecting data. Use <strong>Refresh data</strong> after promotions go out.
          </p>

          <a
            href={MEET_PAGE_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="owner-dashboard__meet-empty-link"
          >
            View live meet page
          </a>
        </>
      )}

      {isSetup && (
        <p className="owner-dashboard__meet-empty-foot">
          Check that GA4 credentials are set on the server, then refresh this dashboard.
        </p>
      )}
    </div>
  );
};

export default MeetPageEmptyState;
